var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20027_24302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20027_24302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 14.1665L12.1432 12.9998L15.9766 9.1665L12.1432 5.33317L13.3307 4.1665L18.3307 9.1665L13.3307 14.1665ZM1.66406 15.8332V12.4998C1.66406 11.3471 2.07031 10.3644 2.88281 9.55192C3.69531 8.73942 4.67795 8.33317 5.83073 8.33317H10.9766L7.97656 5.33317L9.16406 4.1665L14.1641 9.1665L9.16406 14.1665L7.97656 12.9998L10.9766 9.99984H5.83073C5.13628 9.99984 4.54601 10.2429 4.0599 10.729C3.57378 11.2151 3.33073 11.8054 3.33073 12.4998V15.8332H1.66406Z",
    fill: "#9AA0A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignTo);
export default __webpack_public_path__ + "static/media/AssignTo.6799fd880dcf1c48f174f1ae7e1293bd.svg";
export { ForwardRef as ReactComponent };